import axios from 'axios';

const getItensComprasSaldos = params => axios.get('/saldos-entregas', {
  params,
});

const getItensCompra = compraId => axios.get(`/saldos-entregas/compras/${compraId}`);

const updateSaldoEntrega = (id, data) => axios.put(`/saldos-entregas/${id}`, data);

const faturarItemCompra = (id, data) => axios.put(`/saldos-entregas/itens-compras/${id}/faturar`, data);

const entregarItemCompra = (id, data) => axios.put(`/saldos-entregas/itens-compras/${id}/entregar`, data);

const entregarCompra = id => axios.put(`/saldos-entregas/compras/${id}/entregar`, {});

const getItemCompraSaldos = id => axios.get(`/saldos-entregas/itens-compras/${id}`);

const updateSaldosPendentes = (id, data) => axios.put(`/saldos-entregas/itens-compras/${id}/saldos-pendentes`, data);

const cancelarSaldo = id => axios.put(`/saldos-entregas/${id}/cancelar`, {});

export default {
  getItensComprasSaldos,
  getItensCompra,
  getItemCompraSaldos,
  updateSaldoEntrega,
  faturarItemCompra,
  entregarItemCompra,
  updateSaldosPendentes,
  cancelarSaldo,
  entregarCompra,
};
